export default {
  translation: {
    welcome: 'Welcome to our Wedding!',
    rsvp: 'RSVP',
    enterToken: 'Please enter your invitation token',
    submit: 'Submit',
    name: 'Name',
    attendingCeremony: 'Attending ceremony?',
    attendingReception: 'Attending reception?',
    yes: 'Yes',
    no: 'No',
    primaryGuest: 'Your Details',
    dietaryRestrictions: 'Dietary Restrictions',
    dietaryRestrictionsPlaceholder: 'Please list any allergies or dietary restrictions...',
    menuChoice: 'Menu Choice',
    menuStandard: 'Standard',
    menuVegetarian: 'Vegetarian',
    menuVegan: 'Vegan',
    menuKids: 'Kids Menu',
    additionalGuests: 'Additional Guests',
    guest: 'Guest',
    guestNamePlaceholder: 'Guest name',
    ageGroup: 'Age Group',
    adult: 'Adult menu',
    child: 'Child buffet',
    baby: 'Baby high chair',
    addGuest: 'Add Guest',
    removeGuest: 'Remove',
    message: 'Message for the couple',
    messagePlaceholder: 'Share your wishes or any additional information...',
    thankYou: 'Thank you for your response!',
    error: 'An error occurred. Please try again.',
    invalidToken: 'Invalid token. Please check and try again.',
    attendingGeneral: 'Will you attend?',
    attendingYes: 'Yes',
    attendingNo: 'No',
    pleaseSelect: 'Please select...',
    menuType: 'Menu Type',
    starter: 'Starter',
    main: 'Main',
    dessert: 'Dessert',
    restrictions: 'Dietary Restrictions',
    submitSuccess: 'Your RSVP has been submitted!',
    submitError: 'An error occurred while submitting. Please try again.',

    // Wedding details
    weddingDetails: 'Wedding Details',
    ceremony: 'Ceremony',
    ceremonyDate: 'August 20, 2025',
    ceremonyTime: 'Starting at 16:00, arrival from 15:30',
    ceremonyLocation: 'Old Marylebone Town Hall',
    ceremonyAddress: 'Westminster Council House, 97-113 Marylebone Rd, London NW1 5PT',
    ceremonyDescription: `We are delighted to invite you to witness our marriage ceremony at the historic Old Marylebone Town Hall. The wedding ceremony will be starting at 16:00 (on the dot) in the Westminster room and will be around 20 minutes long.<1/>
      Guests can arrive in the Westminster Room from 15:30, luggage and prams will need to be left in the foyer.<1/>
      Afterwards we will take a photo on the steps of Old Marylebone Town Hall`,
    ceremonyTransport:
      'Baker Street (Bakerloo, Circle, Hammersmith and City, Jubilee & Metropolitan lines). Among many other buses, there is also the 18 just outside.',

    reception: 'Reception',
    receptionDate: 'August 20, 2025',
    receptionTime: 'From 17:30',
    receptionLocation: 'The William Pub',
    receptionAddress: '786 Harrow Road, Kensal Green, London NW10 5JX',
    receptionTransport: 'Kensal Green (Bakerloo Line), Kensal Green Cemetery (18er Bus)',
    receptionDescription:
      'Following the ceremony, please join us for dinner and dancing at The William Pub in Kensal Green, a charming venue where we will celebrate into the evening.',

    // FAQ section
    faqTitle: 'Frequently Asked Questions',
    loading: 'Loading...',
    faqLoadError: 'Unable to load FAQs. Please try again later.',
    noFaqsAvailable: 'No FAQs are currently available.',
  },
};
